module.exports = __webpack_public_path__ + "img/bg-gc-car.cf837e6f.png";